import { Fragment, useCallback, useEffect, useState } from "react";
import { AiOutlineSortAscending, AiOutlineSortDescending } from "react-icons/ai";

import Row from "./row/row.component";

import "./accountant-table.style.scss";

const COLUMNS = {
	company: "Client Company",
	id: "ID Number",
	filler: "",
};

const SORT_DIRECTIONS = {
	ascending: "ascending",
	descending: "descending",
	none: "none",
};

const Table = ({
	searchText = ["", false],
	data: _data,
	extraData,
	initialIndex,
	onRowClick,
	onDelete = null,
}) => {
	const [data, setData] = useState(_data);
	const [sort, setSort] = useState(["", SORT_DIRECTIONS.none]); // [sortKey, direction]
	const [expandedIndex, setExpandedIndex] = useState(initialIndex);

	const filterTable = useCallback(
		(text) => {
			if (text === "") {
				setData(_data);
				return;
			}

			setData(() => {
				const newValue = [..._data];
				return newValue.filter((client) => {
					const isPersonalAccount = client.companyType === 0;
					if (isPersonalAccount) return client.name.toLowerCase().includes(text.toLowerCase());
					return client.company.name.toLowerCase().includes(text.toLowerCase());
				});
			});
		},
		[_data]
	);

	useEffect(() => {
		setData(_data);
	}, [_data]);

	useEffect(() => {
		if (searchText[1]) {
			filterTable(searchText[0]);
		}
	}, [searchText, filterTable]);

	const changeSort = useCallback(
		(sortKey) => {
			if (sort[0] !== sortKey) {
				setSort([sortKey, SORT_DIRECTIONS.ascending]);
				return SORT_DIRECTIONS.ascending;
			}
			// if (sort[0] === sortKey) ...
			if (sort[1] === SORT_DIRECTIONS.ascending) {
				setSort([sortKey, SORT_DIRECTIONS.descending]);
				return SORT_DIRECTIONS.descending;
			}
			if (sort[1] === SORT_DIRECTIONS.descending) {
				setSort(["", SORT_DIRECTIONS.none]);
				return SORT_DIRECTIONS.none;
			}
		},
		[sort]
	);

	const handleSort = useCallback(
		(sortKey) => {
			const direction = changeSort(sortKey);
			setData((prevData) => {
				if (direction === SORT_DIRECTIONS.none) return _data;

				const tempData = [...prevData];
				tempData.sort((row1, row2) => {
					const row1CompanyType = row1.companyType;
					const row2CompanyType = row2.companyType;
					const a =
						sortKey === "id" ? row1.id : row1CompanyType === 0 ? row1.name : row1.company.name;
					const b =
						sortKey === "id" ? row2.id : row2CompanyType === 0 ? row2.name : row2.company.name;
					if (a > b) return direction === SORT_DIRECTIONS.ascending ? 1 : -1;
					if (a < b) return direction === SORT_DIRECTIONS.ascending ? -1 : 1;
					return 0;
				});
				return tempData;
			});
		},
		[_data, changeSort]
	);

	const handleRowClick = (row, index) => {
		var companyName = "";
		if (row.companyType === 0) {
			companyName = row.name + " " + row.surname;
		} else {
			companyName = row.company.name;
		}

		if (onRowClick) {
			onRowClick(companyName);
			return;
		}
		handleExpand(index);
	};

	const handleExpand = (index) => {
		setExpandedIndex((prevIndex) => {
			return index === prevIndex ? null : index;
		});
	};

	return (
		<div className="accountant-table-container">
			{data.length === 0 && (
				<div className="size400 w500 margin-m--bottom empty-table">There are no clients</div>
			)}
			<table>
				{data.length > 0 && (
					<Fragment>
						<thead className={`${onDelete && "with-delete"}`}>
							<tr className="size400 w500">
								{Object.keys(COLUMNS).map((key) => {
									const column = COLUMNS[key];
									return (
										<th key={column}>
											{column}

											{column && (
												<span
													onClick={() => {
														handleSort(key);
													}}
													className="sort-button-wrapper"
												>
													{sort[0] !== key && (
														<AiOutlineSortDescending className="sort-button none" />
													)}
													{sort[0] === key && sort[1] === SORT_DIRECTIONS.none && (
														<AiOutlineSortDescending className="sort-button none" />
													)}
													{sort[0] === key && sort[1] === SORT_DIRECTIONS.ascending && (
														<AiOutlineSortDescending className="sort-button" />
													)}
													{sort[0] === key && sort[1] === SORT_DIRECTIONS.descending && (
														<AiOutlineSortAscending className="sort-button" />
													)}
												</span>
											)}
										</th>
									);
								})}
								{onDelete && <th></th>}
							</tr>
						</thead>
						<tbody className={`scroll-bar scroll-bar--overflow ${onDelete && "with-delete"}`}>
							{data.map((row, index) => {
								return (
									<Row
										key={index}
										row={row}
										index={index}
										extraData={extraData ?? []}
										onClick={() => {
											handleRowClick(row, index);
										}}
										isExpanded={index === expandedIndex}
										onDelete={
											onDelete
												? () => {
														onDelete(index);
												  }
												: null
										}
									/>
								);
							})}
						</tbody>
					</Fragment>
				)}
			</table>
		</div>
	);
};
export default Table;
